module.exports = __webpack_public_path__ + "talent-cover.png?8d82de9d1362ce3b7ab3eccaa4b34d01";